import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import {
  Form,
  Button,
  Container,
  Alert,
  Breadcrumb,
  Card,
} from "react-bootstrap";
import Layout from "../page/layout";

const FormEditRencanaTanam = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const [formData, setFormData] = useState({
    catatantambahan: "",
  });
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const fetchTanamDetails = useCallback(async () => {
    if (!token) {
      console.error("Token tidak ditemukan");
      setError("Token tidak ditemukan");
      setLoading(false);
      return;
    }

    try {
      console.log("Fetching data untuk ID:", id);
      const response = await axios.get("https://c-greenproject.org:8000/petanisapproved", {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true,
      });

      if (!Array.isArray(response.data)) throw new Error("Format data tidak valid");

      const tanamData = response.data
        .flatMap(entry => entry.rencanaTanamInfo?.map(rt => ({
          ...rt,
          petanidasar: entry.petanidasar,
        })) || [])
        .find(item => item.idtanam === id);

      if (tanamData) {
        setFormData({ catatantambahan: tanamData.catatantambahan || "" });
      } else {
        setError("Rencana Tanam tidak ditemukan");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setError(error.message || "Terjadi kesalahan saat mengambil data");
    } finally {
      setLoading(false);
    }
  }, [id, token]);

  useEffect(() => {
    fetchTanamDetails();
  }, [fetchTanamDetails]);

  const updateRencanaTanam = async (e) => {
    e.preventDefault();
    setMsg("");

    if (!id) {
      setMsg("ID Tanam tidak ditemukan.");
      return;
    }
    if (!token) {
      setMsg("Token tidak ditemukan, harap login ulang.");
      return;
    }

    try {
      const response = await axios.put(
        `https://c-greenproject.org:8000/petanisapproved/${id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200 || response.status === 204) {
        setMsg("Data berhasil diperbarui!");
        await new Promise(resolve => setTimeout(resolve, 1000));
        await fetchTanamDetails();
        setTimeout(() => navigate("/rencanatanam", { replace: true }), 1500);
      } else {
        setMsg("Gagal memperbarui rencana tanam.");
      }
    } catch (error) {
      console.error("Error saat update:", error);
      setMsg("Gagal memperbarui rencana tanam. Periksa kembali data Anda.");
    }
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p className="text-danger">{error}</p>;

  return (
    <Layout>
      <Container>
        <Breadcrumb>
          <Breadcrumb.Item href="/rencanatanam">Rencana Tanam</Breadcrumb.Item>
          <Breadcrumb.Item active>Edit Rencana Tanam</Breadcrumb.Item>
        </Breadcrumb>

        <h2 className="my-4">
          <strong>Edit Rencana Tanam</strong>
        </h2>
        {msg && <Alert variant="danger">{msg}</Alert>}

        <Card className="p-4 mb-3 shadow">
          <Form onSubmit={updateRencanaTanam}>
            <Form.Group className="mb-3">
              <Form.Label>Catatan Tambahan</Form.Label>
              <Form.Control
                as="textarea"
                name="catatantambahan"
                value={formData.catatantambahan}
                onChange={handleChange}
              />
            </Form.Group>

            <Button variant="success" type="submit">
              Update
            </Button>
          </Form>
        </Card>
      </Container>
    </Layout>
  );
};

export default FormEditRencanaTanam;
